// @flow

import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import Quiz from "./pages/quiz";
import QuizQR from "./pages/quizQR";
import SlopeFactors from "./pages/slope-factors";
import SlopeWealth from "./pages/slope-wealth";
import InternalSurvey from "./pages/internal-survey";
import Index from "./pages/index";

const render = () => {
  const width = window.innerWidth;
  const page = window.location.hash;
  const App = page === "#quiz"
    ? Quiz
    : page === "#quizQR"
      ? QuizQR
      : page === "#slope-factors"
        ? SlopeFactors
        : page === "#slope-wealth"
          ? SlopeWealth
          : page === "#internal-survey" ? InternalSurvey : Index;

  ReactDOM.render(<App width={width} />, document.getElementById("root"));
};

window.addEventListener("hashchange", render);
window.addEventListener("resize", render);

render();



// WEBPACK FOOTER //
// ./src/index.js